var _defs, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-4 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-6 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.25,12.81l7.05,14.29c.15.3.43.5.75.55l15.77,2.29c1.6.23,2.24,2.2,1.08,3.32l-11.41,11.13c-.24.23-.34.56-.29.89l2.69,15.71c.27,1.59-1.4,2.81-2.83,2.05l-14.11-7.42c-.29-.15-.64-.15-.93,0l-14.11,7.42c-1.43.75-3.1-.46-2.83-2.05l2.69-15.71c.06-.32-.05-.66-.29-.89l-11.41-11.13c-1.16-1.13-.52-3.09,1.08-3.32l15.77-2.29c.33-.05.61-.25.75-.55l7.05-14.29c.71-1.45,2.78-1.45,3.5,0Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(0 -5.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 4.6,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 9.4,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.76,
    y: 0
  }, "ouri"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 29.86,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.27,
    y: 0
  }, "e - "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 46.66,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.64,
    y: 0
  }, "n"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteOn);
export default __webpack_public_path__ + "static/media/__Favourite - On.5898d3afaa128839855a0e4cba5db615.svg";
export { ForwardRef as ReactComponent };